import { create } from 'zustand';

export type DrawerItemType = 'order' | 'lead' | 'klant';

export interface InboxDrawerOpenItem {
  type: DrawerItemType;
  id: string;
  /** Alleen bij type 'klant': account of lead (KlantDetailView). */
  klantType?: 'account' | 'lead';
}

interface InboxDrawerState {
  openItem: InboxDrawerOpenItem | null;
  open: (type: DrawerItemType, id: string, extra?: { klantType?: 'account' | 'lead' }) => void;
  close: () => void;
}

export const useInboxDrawerStore = create<InboxDrawerState>((set) => ({
  openItem: null,
  open: (type, id, extra) => set({ openItem: { type, id, ...(extra?.klantType ? { klantType: extra.klantType } : {}) } }),
  close: () => set({ openItem: null }),
}));

/** Encode drawer state for the `?open=` query param. */
export function encodeDrawerParam(item: InboxDrawerOpenItem | null): string | null {
  if (!item) return null;
  return item.type === 'klant' ? `klant:${item.klantType || 'account'}:${item.id}` : `${item.type}:${item.id}`;
}

/** Parse the `?open=` query param back into drawer state. */
export function parseDrawerParam(raw: string | null): InboxDrawerOpenItem | null {
  if (!raw) return null;
  const [type, ...rest] = raw.split(':');
  const id = rest.join(':');
  if (!id) return null;
  if (type === 'klant') {
    const [klantType, ...idRest] = rest;
    const klantId = idRest.join(':');
    if (!klantId || (klantType !== 'account' && klantType !== 'lead')) return null;
    return { type, id: klantId, klantType };
  }
  if (type !== 'order' && type !== 'lead') return null;
  return { type, id };
}
